<template>
  <div class="contact_page">
    <div class="banner">
      <el-carousel trigger="click" height="374px" style="width: 100%;">
        <el-carousel-item v-for="item in banners" :key="item.id">
          <img :src="url+item.imageUrl" height="100%" width="100%"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="page_wrapper">
      <div class="contact_info">
        <el-row :gutter="20">
          <el-col :span="8">
            <span>联系电话：{{ sysInfo.phone }}</span>
          </el-col>
          <el-col :span="8">
            <span>中心网址：{{ sysInfo.centralUrl }}</span>
          </el-col>
          <el-col :span="8">
            <span>邮 箱：{{ sysInfo.email }}</span>
          </el-col>
          <el-col :span="8">
            <span>详细地址：{{ sysInfo.address }}</span>
          </el-col>
          <el-col :span="8">
            <span>邮 编：{{ sysInfo.postcode }}</span>
          </el-col>
        </el-row>
      </div>
      <div class="contact_intro" v-html="sysInfo.contactInfo"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/preview/',
      banners:[],
      sysInfo:{}
    };
  },
  created(){
    this.getBanner();
    this.getSys();
  },
  methods: {
    getSys(){
      this.$http.get(this.$api.systemApi.getSys).then(({ data }) => {
        this.sysInfo = data.data;
      });
    },
    getBanner(){
      this.$http.get(this.$api.systemApi.banners+'?type=BANNER_LXWM_PC').then(({ data }) => {
        this.banners = data.data;
      }).catch(() => {
        this.banners = [];
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.contact_page {
  .banner {
    display: flex;
    img {
      display: block;
      flex: 1;
    }
  }
  .contact_info {
    line-height: 30px;
    background: #ffffff;
    padding: 34px 65px;
    border-radius: 16px;
    font-size: 15px;
    font-weight: bold;
    // margin-top: -72px;
    margin-top: 20px;
    z-index: 4;
    position: relative;
  }
  .contact_intro {
    padding: 34px 65px;
    margin-top: 16px;
    margin-bottom: 55px;
    background: #fff;
    border-radius: 16px;
    line-height: 34px;
    font-size: 15px;
    text-indent: 2em;
    min-height: 300px;
  }
}
</style>
